
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../App.jsx';
import { Shield, Lock, Mail, ChevronRight } from 'lucide-react';
import TerviLogo from '../../components/common/TerviLogo.jsx';

const AdminLoginScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { signIn, showMessage } = useAppContext();
    const navigate = useNavigate();

    const handleAdminLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await signIn(email, password);
            showMessage("Credenciais validadas. Bem-vindo.", "success");
            navigate('/admin');
        } catch (error) {
            console.error(error);
            showMessage("Acesso negado. Verifique os dados.", "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="h-full flex flex-col items-center justify-center bg-slate-950 relative overflow-hidden p-6">

            {/* Background Atmosphere */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none"></div>

            <div className="mb-10 relative z-10">
                <TerviLogo size={40} color="white" />
            </div>

            <div className="w-full max-w-sm relative z-10">
                <div className="bg-slate-900/40 backdrop-blur-2xl rounded-[2.5rem] p-8 border border-slate-800/50 shadow-[0_20px_50px_rgba(0,0,0,0.5)]">

                    <div className="flex flex-col items-center mb-8">
                        <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-700 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-900/20 mb-4 border border-blue-400/20">
                            <Shield className="text-white w-7 h-7" />
                        </div>
                        <h1 className="text-lg font-black text-white uppercase tracking-[0.2em]">
                            Portal Admin
                        </h1>
                        <div className="flex items-center mt-1">
                            <div className="h-[1px] w-4 bg-slate-700"></div>
                            <p className="text-[9px] text-slate-500 font-bold uppercase tracking-[0.15em] mx-3 text-center leading-none">
                                Gestão de Ecossistema
                            </p>
                            <div className="h-[1px] w-4 bg-slate-700"></div>
                        </div>
                    </div>

                    <form onSubmit={handleAdminLogin} className="space-y-5">
                        <div className="group relative">
                            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 w-4 h-4 transition-colors" />
                            <input
                                type="email"
                                name="email"
                                autoComplete="username"
                                placeholder="E-mail de Acesso"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full pl-11 pr-4 py-4 bg-slate-950/50 border border-slate-800 focus:border-blue-500/50 rounded-2xl text-white text-sm outline-none transition-all font-medium placeholder:text-slate-600 focus:ring-4 focus:ring-blue-500/5"
                            />
                        </div>

                        <div className="group relative">
                            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 w-4 h-4 transition-colors" />
                            <input
                                type="password"
                                name="password"
                                autoComplete="current-password"
                                placeholder="Código de Segurança"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full pl-11 pr-4 py-4 bg-slate-950/50 border border-slate-800 focus:border-blue-500/50 rounded-2xl text-white text-sm outline-none transition-all font-medium placeholder:text-slate-600 focus:ring-4 focus:ring-blue-500/5"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full py-4 mt-2 bg-white text-slate-950 font-black rounded-2xl shadow-xl hover:bg-blue-50 transition-all active:scale-[0.97] flex items-center justify-center uppercase tracking-widest text-xs disabled:opacity-50"
                        >
                            {isLoading ? 'Autenticando...' : (
                                <>
                                    Entrar no Painel <ChevronRight size={16} className="ml-1" />
                                </>
                            )}
                        </button>
                    </form>
                </div>

                <div className="mt-8 flex flex-col items-center">
                    <p className="text-[9px] text-slate-600 font-black uppercase tracking-[0.4em] mb-4">
                        Security Standard V1.0
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AdminLoginScreen;
